// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-container{
    width: 100%;
    display: flex;
    gap: 5em;
    flex-direction: column;
    align-items: flex-start;
    padding: 6em 4em 2em 6em;
}

.blog-container > * {
    margin: 0;
    padding: 0;
}

.footer-container {
    z-index: 100;
}

.blog-main-category {
    text-transform: capitalize;
    text-decoration: underline;
}

.blog-banner-img {
    width: 100%;
    height: 20em;
    object-fit: cover;
}

.blog-content {
    color: #fff;
    font-size: 1em;
    font-weight: 100;
}

.blog-content a {
    color: #fff;
}

.blog-content ul {
    padding-left: 1em;
}

.blog-social {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 1em;
}

.blog-content-images-container {
    display: flex;
    gap: 1em;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
}

.blog-content-image {
    max-width: 25em;
    max-height: 20em;
    object-fit: cover;
}

@media screen and (max-width: 768px) {
    .blog-container{
        width: 100%;
        align-items: center;
        padding: 6em 3em 2em;
    }
    
    .blog-container > * {
        margin: 0;
        padding: 0;
    }

    .blog-banner-img {
        width: 100%;
        height: 10em;
        object-fit: cover;
    }
        
    .footer-container {
        z-index: 100;
    }

    .blog-content-image {
        width: 100%;
        height: 15em;
    }

    .blog-social {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/blog.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".blog-container{\n    width: 100%;\n    display: flex;\n    gap: 5em;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 6em 4em 2em 6em;\n}\n\n.blog-container > * {\n    margin: 0;\n    padding: 0;\n}\n\n.footer-container {\n    z-index: 100;\n}\n\n.blog-main-category {\n    text-transform: capitalize;\n    text-decoration: underline;\n}\n\n.blog-banner-img {\n    width: 100%;\n    height: 20em;\n    object-fit: cover;\n}\n\n.blog-content {\n    color: #fff;\n    font-size: 1em;\n    font-weight: 100;\n}\n\n.blog-content a {\n    color: #fff;\n}\n\n.blog-content ul {\n    padding-left: 1em;\n}\n\n.blog-social {\n    position: fixed;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n}\n\n.blog-content-images-container {\n    display: flex;\n    gap: 1em;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: center;\n}\n\n.blog-content-image {\n    max-width: 25em;\n    max-height: 20em;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 768px) {\n    .blog-container{\n        width: 100%;\n        align-items: center;\n        padding: 6em 3em 2em;\n    }\n    \n    .blog-container > * {\n        margin: 0;\n        padding: 0;\n    }\n\n    .blog-banner-img {\n        width: 100%;\n        height: 10em;\n        object-fit: cover;\n    }\n        \n    .footer-container {\n        z-index: 100;\n    }\n\n    .blog-content-image {\n        width: 100%;\n        height: 15em;\n    }\n\n    .blog-social {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
